import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {Link} from 'react-router';
import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import MyStableButton from 'modules/Common/containers/Subscriptions/MyStableButton';
import { localDayOfWeek, localShortDayOfWeek } from 'utils/LocalDateTimeHelper';
import BetLink from 'modules/Common/containers/BetLink';
import { racecardResultHref, rideDetailsFromEntry } from 'modules/HorseRacing/utils';
import { compareStrings } from 'utils/compare.js';

export default class HorseRacingAbcTable extends Component {
  static propTypes = {
      rides: PropTypes.array,
      days: PropTypes.string
  }

  render() {
    const {
      rides,
      days
    } = this.props;

    const orderedRides = rides.sort((...items) => compareStrings(...items.map(({ride: {horse: {name}}}) => name)));
    const hideDays = days == '5-days' ? "" : "hideDays";

    return <table className={`default-table ${hideDays}`}>
        <thead>
          <tr className="horse-abc-row">
            <th className="horse-name heading" colSpan="2">Horse</th>
            <th className="race-name heading">Race</th>
            <th className="race-day heading">Day</th>
            <th className="abc-guide-odds heading">Odds</th>
          </tr>
        </thead>
        <tbody>
          {orderedRides.map(entry => {
            const {
              ride: {
                ride_reference: {
                  id: rideId
                },
                horse: {
                  horse_reference: {
                    id: horseId
                  },
                  name: horseName
                },
                betting: {
                  current_odds: odds
                }
              },
              race: {
                race_summary: {
                  date: raceDate
                }
              }
            } = entry;

            const entryDetails = rideDetailsFromEntry(entry);

            return <tr key={rideId} className="horse-abc-row">
              <td className="horse-name">
                <Link to={`/racing/profiles/horse/${horseId}`}>{horseName}</Link>
              </td>
              <td className="abc-guide-my-stable">
                <SubscriptionContainer
                  addSubscriptions={ [{ type: "HORSE", id: horseId, text: horseName }] }
                  icon={ <MyStableButton noText/> }
                />
              </td>
              <td className="race-name">
                <Link to={racecardResultHref(entryDetails.raceLinkDetails)}>{entryDetails.raceLinkDetails.eventName}</Link>
                <div className="race-short-day">{localShortDayOfWeek(raceDate)}</div>
              </td>
              <td className="race-day">{localDayOfWeek(raceDate)}</td>
              <td className="abc-guide-odds">
                { !!entryDetails.betlinkProps &&
                  <BetLink className='hr-racing-runner-betting-link sui-odds' {...entryDetails.betlinkProps}>{odds}</BetLink>
                }
              </td>
            </tr>;
          })}
        </tbody>
      </table>;
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingAbcTable.js